import { isTrackingEvent, TrackingEvent } from '../../tracking';

export interface YattaLinkBase {
  class?: string | null;
  trackingEvent?: TrackingEvent | null;
  id?: string | null;
}

export function isYattaLinkBase(value: unknown): value is YattaLinkBase {
  return (
    typeof value === 'object' &&
    value !== null &&
    (!('class' in value) || value.class === undefined || value.class === null || typeof value.class === 'string') &&
    (!('trackingEvent' in value) || value.trackingEvent === undefined || value.trackingEvent === null || isTrackingEvent(value.trackingEvent))
  );
}
